import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../../components/Header'
import hero from '../../images/drive-america__hero.jpg'
import img01 from '../../images/driveamerica-1.jpg'
import img02 from '../../images/driveamerica-2.jpg'
import img03 from '../../images/driveamerica-3.jpg'

const Page = () => (
  <Fragment>
    <Helmet
      title="DriveAmerica™ | What We Offer"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">DriveAmerica™</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__images c-golden__short min-laptop">
          <img src={img01} alt="" style={{ width: '50%', height: '100%' }} />
          <img src={img02} alt="" style={{ width: '50%', height: '50%' }} />
          <img src={img03} alt="" style={{ width: '50%', height: '50%' }} />
        </div>
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/what-we-offer">What We Offer</Link>
            </li>
            <li>
              <Link
                to="/what-we-offer/drive-america"
                activeClassName="is-active"
              >
                DriveAmerica™
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <h1 className="t-h1">
              Nothing defines the American spirit like the call of the open road
              </h1>
              <p className="t-p t-p-light mt30">
                ATI’s DriveAmerica™ self-drive tours deliver inspired
                itineraries, door to door driving instructions with local
                attraction and activity information along the route, and
                guaranteed hotel accommodations throughout your entire trip.
              </p>
              <p className="t-p t-p-light mt30">
                Our flexible booking system allows for you to either customize
                your very own road trip from scratch or to utilize and make your
                desired changes to one of our many recommended DriveAmerica™
                itineraries. The only thing you need is the spirit of adventure!
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/what-we-offer/drive-america.js